import { ServicePoint } from './servicePoint';

export enum enumAccessControl {
  All = 1,
  'Merchant Only',
  Selection,
  Group
}

export namespace enumAccessControl {
  export function values() {
    return Object.keys(enumAccessControl).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}

export function AccessControlToArray(): object[] {
  return Object.keys(enumAccessControl)
    .filter(key => typeof enumAccessControl[key] === 'number')
    .map(key => ({ id: enumAccessControl[key], itemName: key }));
}


export interface GidAccessControl {
  // See C001 - 2026-04-15 - HE
  // // portalRegisterId: [{id: number}];
  portalRegisterId?: { id: number }[];
  uacId?: number;
  id: number; 
  defaultGid: number;
  defaultSPS: ServicePoint;
  accessControl: enumAccessControl;
  selectionList: ServicePoint[];
  exclusionList: ServicePoint[];
}

// ========================================
// CHANGE LOG
// ========================================
// C001: Declared portalRegisterId on GidAccessControl. What changed: Added optional property portalRegisterId?: { id: number }[] to interface; kept prior commented stub as audit trail. Previous behavior: portalRegisterId was only a commented line, so TypeScript had no property and UserAccessControlService references failed compilation (TS2339). New behavior: Interface matches PADM NewAccessControlRequest payload and create/update access flows. Reason: Align model with user-access-control.service normalizePortalRegisterIdForApi and portaladmin gid form. Impact: GidAccessControl consumers may type-check portalRegisterId; no runtime change. - 2026-04-15 - HE
